import axios from '../../axios/index.js';

export default {
    /**
     * Get Timeline data
     *
     * @param url
     * @param params
     * @returns {*}
     */
    getTimelineData (url, params) {
        return axios.get(url, { params: params });
    },
};
